import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { LegacyCardDataHooks } from './constant';

export interface LegacyCardDriver extends BaseUniDriver {
  getMediaContent(): Promise<HTMLElement>;
  getInfoContent(): Promise<HTMLElement>;
  getRatio(): Promise<string>;
  isFlippedRatio(): Promise<boolean>;
  isImagePositionInverted(): Promise<boolean>;
  isMediaContentExist(): Promise<boolean>;
  isInfoContentExist(): Promise<boolean>;
  isMobile(): Promise<boolean>;
}

export const legacyCardDriverFactory = (base: UniDriver): LegacyCardDriver => {
  const getMediaContainerElement = () =>
    base.$(`[data-hook="${LegacyCardDataHooks.mediaContainer}"] > *`);
  const getInfoContainerElement = () =>
    base.$(`[data-hook="${LegacyCardDataHooks.infoContainer}"] > *`);

  return {
    ...baseUniDriverFactory(base),
    getMediaContent: async () => getMediaContainerElement().getNative(),
    isMediaContentExist: async () => getMediaContainerElement().exists(),
    getInfoContent: async () => getInfoContainerElement().getNative(),
    isInfoContentExist: async () => getInfoContainerElement().exists(),
    getRatio: async () => base.attr('data-ratio'),
    isFlippedRatio: async () =>
      (await base.attr('data-is-flipped-ratio')) === 'true',
    isImagePositionInverted: async () =>
      (await base.attr('data-is-inverted')) === 'true',
    isMobile: async () => (await base.attr('data-mobile')) === 'true',
  };
};
